/**
 * Natvral Lavde — colapso estable de la fila de categorías del header.
 *
 * Por qué existe: usar data-sticky-state (IntersectionObserver threshold:1)
 * o data-scroll-direction (comparación de scrollTop frame a frame) como
 * disparador del colapso provoca parpadeo. Ambos se recalculan en cada
 * frame de scroll y son sensibles a ruido de subpíxel / momentum del
 * trackpad: durante un scroll continuo el signo del delta puede oscilar de
 * un frame a otro sin que el usuario haya cambiado de dirección realmente,
 * reiniciando la transición de colapso una y otra vez.
 *
 * Este script evita ese ruido usando la posición absoluta de scroll (no el
 * delta) con dos umbrales distintos para colapsar y expandir (histéresis):
 * mientras el scroll se mantenga en la zona intermedia entre ambos, el
 * estado no cambia, así que un scroll ligeramente inestable no provoca
 * parpadeo.
 */
(function () {
  var COLLAPSE_AT = 48; // px scrolleados para colapsar la fila de categorías
  var EXPAND_AT = 8; // px scrolleados por debajo de los cuales se vuelve a expandir

  var header = null;
  var collapsed = false;
  var rafId = null;

  function setCollapsed(state) {
    if (state === collapsed) return;
    collapsed = state;
    if (header) {
      header.toggleAttribute('data-nl-categories-collapsed', collapsed);
    }
  }

  function check() {
    rafId = null;
    if (!header) return;
    var y = window.scrollY || document.documentElement.scrollTop || 0;

    if (!collapsed && y > COLLAPSE_AT) {
      setCollapsed(true);
    } else if (collapsed && y < EXPAND_AT) {
      setCollapsed(false);
    }
  }

  function onScroll() {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(check);
  }

  function init() {
    header = document.getElementById('header-component');
    if (!header) return;

    check(); // estado inicial correcto si la página carga ya desplazada
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
